export default __webpack_public_path__ + "static/media/logo-enviar-palta.c4d1eb5b.png";